import { api, unwrapData } from '../../../app/store/api';
import { ApiResponse, PaginatedResponse } from '../../../types';

type ReportGatewayOption = {
    id: number;
    title: string;
    status: 'activated' | 'pending' | 'rejected';
};

export const reportApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getReportGateways: builder.query<ReportGatewayOption[], void>({
            transformResponse: unwrapData,
            query: () => ({
                url: 'reports/gateways',
                method: 'GET',
            }),
        }),

        getReportsList: builder.query<
            PaginatedResponse<unknown>,
            { page?: number; perPage?: number; search?: any }
        >({
            transformResponse: unwrapData,
            query: ({ page, perPage = 15, search }) => ({
                url: 'reports',
                method: 'GET',
                params: {
                    ...(page && { page }),
                    ...(perPage && { per_page: perPage }),
                    ...search,
                },
            }),
        }),
    }),
});

export const { useGetReportsListQuery, useGetReportGatewaysQuery } = reportApi;

export default reportApi;
